
function NotFound() {
    return(
        <div className="m-1">
           <h1>404 NotFound</h1>
            
        </div>
    )
}


export { NotFound }